import type { KpiCardSpec } from './card-spec';

/**
 * The full-app active-users scalar, shown on both the Overview featured row and
 * the Users page's Active users section. One object in two catalogs, so the two
 * pages cannot report different figures under the same title.
 */
export const ACTIVE_USERS_SCALAR_CARD: KpiCardSpec = {
    title: 'Total active users',
    source: 'login-activity',
    form: 'number',
    metric: 'activeUsers',
    // The trend is back. It was hard-off while this read app-active-users,
    // whose last_login_at source keeps only the most recent login, so it had
    // to anchor on today and could not compare two periods honestly. The
    // login-day table records one row per user per day, so the selected
    // period is a real count and the delta is a real delta.
    size: 'sm',
    description:
        'Users who signed in to the Couche-Tard or Circle K app during the selected period, counted once each. Follows the page Period and Region filters, with a period-over-period delta. Full-app sign-in history starts 2026-08-10, so a period reaching further back reads short.',
};
